module.exports = __webpack_public_path__ + "static/media/9D.82ad06e8.svg";